import { Slide } from '@redbubble/design-system/src/Carousel';
import Stack from '@redbubble/design-system/src/Stack';
import { noop } from 'lodash';

interface CarouselSlideProps {
  children: React.ReactNode;
  key: string;
}

export const CarouselSlide = ({ children, key }: CarouselSlideProps) => {
  return (
    <Slide inView key={key} onUnmount={noop}>
      <Stack spacing="m">{children}</Stack>
    </Slide>
  );
};
